module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Comments for note " + _vm._s(_vm.transaction.transactionId))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-lg"
  }, [_vm._t("body", [_c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("Please append your comment below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "transactionComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-lg"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-save-comment",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.saveComment()
      }
    }
  }, [_vm._v("Save comment")])])])])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baae763c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/EditTransactionComment.vue
// module id = 2198
// module chunks = 1